import axios from "axios";
import { initializeApp } from "firebase/app";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { Link, useLoaderData } from "react-router-dom";

const firebaseConfig2 = {
  apiKey: "AIzaSyDHqLpPVzd0Y9SWTpSH1smRmbKv4WUvi-4",
  authDomain: "tutors-today-student.firebaseapp.com",
  projectId: "tutors-today-student",
  storageBucket: "tutors-today-student.appspot.com",
  messagingSenderId: "171808622362",
  appId: "1:171808622362:web:cb9ad091e01bba89988ea3",
};

// Initialize both apps
const app2 = initializeApp(firebaseConfig2, "secondary"); // Named app for storage

// Get storage from the second app
const storage = getStorage(app2);

const MiraiCareerDetails = () => {
  const jobsData = useLoaderData();
  const [formData, setFormData] = useState({});
  const [isLoading, setIsLoading] = useState({}); // Track loading state for each job

  // Handle input changes in the form
  const handleInputChange = (jobId, field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [jobId]: {
        ...prevData[jobId],
        [field]: value,
      },
    }));
  };

  // Handle file upload
  const handleUpload = async (jobId) => {
    const { name, email, phone, address, expectedSalary, pdf } = formData[jobId] || {};
    if (!name || !email || !phone || !address || !expectedSalary || !pdf) {
      toast.error("Please fill all the fields and upload a PDF!");
      return;
    }

    const storageRef = ref(storage, `career-pdfs/${pdf.name}`);
    setIsLoading((prev) => ({ ...prev, [jobId]: true }));

    try {
      // Upload the file to Firebase Storage
      await uploadBytes(storageRef, pdf);
      const downloadURL = await getDownloadURL(storageRef);

      // Send the form data and download URL to your backend
      await axios.post("https://mirai-server.vercel.app/api/career/apply", {
        jobId,
        name,
        email,
        phone,
        address,
        expectedSalary,
        pdfUrl: downloadURL,
      });

      toast.success("Application submitted successfully!");
      setFormData((prevData) => ({ ...prevData, [jobId]: {} })); // Reset form
    } catch (error) {
      console.error(error);
      toast.error("Failed to submit application!");
    } finally {
      setIsLoading((prev) => ({ ...prev, [jobId]: false }));
    }
  };

  return (
    <div>
      <div className="text-justify lg:py-20 sm:py-5 min-h-screen border-t border-blue-200">
        <div className="text-justify w-full  max-w-screen-2xl mx-auto p-4 ">
          <h1 className="text-justify lg:text-5xl sm:text-xl font-semibold font-jost customBlue">
            {jobsData.title}
          </h1>
          <div className="text-justify mt-10">
            <div
              key={jobsData._id}
              className="text-justify border border-gray-300 rounded-xl shadow-lg p-5 font-jost text-gray-700 lg:text-2xl sm:text-md"
            >
              <div className="text-justify flex lg:justify-end sm:text-start">
                <p className="text-justify lg:text-lg sm:text-sm text-gray-600">
                  Posted on: {new Date(jobsData.date).toLocaleDateString()}
                </p>
              </div>

              <div
                className="text-justify lg:mt-6 sm:mt-3 lg:text-xl sm:text-sm"
                dangerouslySetInnerHTML={{ __html: jobsData.content }}
              />

              <div className="text-justify lg:mt-10 sm:mt-2 border-t border-t-gray-500 py-5">
                <h1 className="text-justify lg:my-10 sm:my-2 lg:text-3xl sm:text-xl  font-jost text-blue-900">Please complete the form to apply for this job.</h1>
                <form
                  class="w-full"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleUpload(jobsData._id);
                  }}
                >
                  <div className="text-justify grid lg:grid-cols-2 sm:grid-cols-1 gap-5">
                    <div class="relative z-0 w-full mb-5 group">
                      <input
                        placeholder=""
                        name="name"
                        id="name"
                        type="text"
                        value={formData[jobsData._id]?.name || ""}
                        onChange={(e) =>
                          handleInputChange(
                            jobsData._id,
                            "name",
                            e.target.value
                          )
                        }
                        required
                        class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                      />
                      <label
                        for="name"
                        class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        Your Name
                      </label>
                    </div>

                    <div class="relative z-0 w-full mb-5 group">
                      <input
                        placeholder=""
                        name="email"
                        id="email"
                        type="email"
                        value={formData[jobsData._id]?.email || ""}
                        onChange={(e) =>
                          handleInputChange(
                            jobsData._id,
                            "email",
                            e.target.value
                          )
                        }
                        required
                        class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                      />
                      <label
                        for="email"
                        class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        Email address
                      </label>
                    </div>

                    <div class="relative z-0 w-full mb-5 group">
                      <input
                        placeholder=""
                        type="tel"
                        name="phone"
                        id="phone"
                        value={formData[jobsData._id]?.phone || ""}
                        onChange={(e) =>
                          handleInputChange(
                            jobsData._id,
                            "phone",
                            e.target.value
                          )
                        }
                        required
                        class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                      />
                      <label
                        for="phone"
                        class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        Phone number (123-456-7890)
                      </label>
                    </div>

                    <div class="relative z-0 w-full mb-5 group">
                      <input
                        placeholder=""
                        name="address"
                        id="address"
                        type="text"
                        value={formData[jobsData._id]?.address || ""}
                        onChange={(e) =>
                          handleInputChange(
                            jobsData._id,
                            "address",
                            e.target.value
                          )
                        }
                        required
                        class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                      />
                      <label
                        for="address"
                        class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        Your Address
                      </label>
                    </div>
                    
                    <div class="relative z-0 w-full mb-5 group">
                      <input
                        placeholder=""
                        name="Salary"
                        id="Salary"
                        type="number"
                        value={formData[jobsData._id]?.expectedSalary || ""}
                        onChange={(e) =>
                          handleInputChange(
                            jobsData._id,
                            "expectedSalary",
                            e.target.value
                          )
                        }
                        required
                        class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                      />
                      <label
                        for="Salary"
                        class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        Expected Salary
                      </label>
                    </div>
                    <div className="text-justify flex flex-col gap-2">
                        <label className="text-justify lg:text-2xl sm:text-md font-jost text-gray-500">Upload your CV</label>
                        <input
                      placeholder=""
                      type="file"
                      accept="application/pdf"
                      onChange={(e) =>
                        handleInputChange(
                          jobsData._id,
                          "pdf",
                          e.target.files[0]
                        )
                      }
                
                    />
                    </div>
                  </div>
                  <button 
                  className="text-justify px-8 py-2  lg:text-xl sm:text-sm rounded backGroundCustom mt-5 text-white font-jost"
                  type="submit" disabled={isLoading[jobsData._id]}>
                    {isLoading[jobsData._id] ? "Submitting..." : "Apply"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiraiCareerDetails;
